import { render, staticRenderFns } from "./certificates.vue?vue&type=template&id=490b6474&scoped=true&"
import script from "./certificates.vue?vue&type=script&lang=js&"
export * from "./certificates.vue?vue&type=script&lang=js&"
import style0 from "./certificates.vue?vue&type=style&index=0&lang=css&"
import style1 from "./certificates.vue?vue&type=style&index=1&id=490b6474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490b6474",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\tavo\\source\\repos\\GEG\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('490b6474', component.options)
    } else {
      api.reload('490b6474', component.options)
    }
    module.hot.accept("./certificates.vue?vue&type=template&id=490b6474&scoped=true&", function () {
      api.rerender('490b6474', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\views\\activities\\certificates.vue"
export default component.exports